import React, { useState } from "react";
import {
  Box,
  TextField,
  MenuItem,
  Typography,
  Button,
  Grid,
  FormControl,
  InputLabel,
  Select,
  CircularProgress,
} from "@mui/material";
import { useParams } from "react-router-dom";
import axios from "axios";
import baseURL from "../../config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CrewFeedbackForm = () => {
  const [formData, setFormData] = useState({
    wagesReviewed: "",
    anyVesselTranfer: "No",
    ifYesVesselTransferDate: "",
    tranferVesselName: "",
    mealOrWaterQuality: "",
    anyRemarks: "",
  });

  const [loading, setLoading] = useState(false);
  const { id: crewId } = useParams();

  const handleChange = (field) => (event) => {
    let value = event.target.value;

    if (field === "wagesReviewed") {
      value = value === "true";
    }

    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        crewId,
        wagesReviewed: formData.wagesReviewed,
        anyVesselTranfer: formData.anyVesselTranfer === "Yes",
        ifYesVesselTransferDate:
          formData.anyVesselTranfer === "Yes"
            ? formData.ifYesVesselTransferDate
            : null,
        tranferVesselName:
          formData.anyVesselTranfer === "Yes"
            ? formData.tranferVesselName
            : null,
        mealOrWaterQuality: formData.mealOrWaterQuality,
        anyRemarks: formData.anyRemarks,
      };

      await axios.post(`${baseURL}/api/crewFeedback`, payload);
      toast.success("Feedback submitted successfully!");

      setFormData({
        wagesReviewed: "",
        anyVesselTranfer: "No",
        ifYesVesselTransferDate: "",
        tranferVesselName: "",
        mealOrWaterQuality: "",
        anyRemarks: "",
      });
    } catch (error) {
      console.error(error);
      toast.error("Error submitting feedback.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Crew Feedback Form
      </Typography>

      <Grid container spacing={2}>
        {/* Wages Received */}
        <Grid item xs={12} md={6}>
          <FormControl fullWidth required>
            <InputLabel id="wages-reviewed-label">Wages Received</InputLabel>
            <Select
              labelId="wages-reviewed-label"
              id="wages-reviewed"
              value={formData.wagesReviewed.toString()}
              label="Wages Received"
              onChange={handleChange("wagesReviewed")}
            >
              <MenuItem value="true">Yes</MenuItem>
              <MenuItem value="false">No</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        {/* Any Vessel Transfer */}
        <Grid item xs={12} md={6}>
          <TextField
            select
            fullWidth
            label="Any Vessel Transfer?"
            value={formData.anyVesselTranfer}
            onChange={handleChange("anyVesselTranfer")}
            required
          >
            <MenuItem value="Yes">Yes</MenuItem>
            <MenuItem value="No">No</MenuItem>
          </TextField>
        </Grid>

        {formData.anyVesselTranfer === "Yes" && (
          <>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Transfer Date"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={formData.ifYesVesselTransferDate}
                onChange={handleChange("ifYesVesselTransferDate")}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Transfer Vessel Name"
                variant="outlined"
                value={formData.tranferVesselName}
                onChange={handleChange("tranferVesselName")}
              />
            </Grid>
          </>
        )}

        {/* Meal or Water Quality */}
        <Grid item xs={12} md={6}>
          <TextField
            select
            fullWidth
            label="Meal or Water Quality"
            value={formData.mealOrWaterQuality}
            onChange={handleChange("mealOrWaterQuality")}
            required
          >
            <MenuItem value="Excellent">Excellent</MenuItem>
            <MenuItem value="Good">Good</MenuItem>
            <MenuItem value="Bad">Bad</MenuItem>
          </TextField>
        </Grid>

        {/* Remarks */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            minRows={3}
            label="Any Remarks"
            variant="outlined"
            value={formData.anyRemarks}
            onChange={handleChange("anyRemarks")}
          />
        </Grid>

        {/* Submit Button */}
        <Grid item xs={12}>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
          >
            {loading ? "Submitting..." : "Submit Feedback"}
          </Button>
        </Grid>
      </Grid>

      <ToastContainer position="top-right" autoClose={3000} />
    </Box>
  );
};

export default CrewFeedbackForm;
